import { z } from 'zod';
import { timestampSchema } from './common.schemas';

/**
 * User Management Schemas
 */

// User object
export const userSchema = z
  .object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string(),
    role: z.enum(['admin', 'agent', 'viewer']),
    status: z.enum(['active', 'invited', 'suspended']),
    lastActiveAt: z.coerce.date().nullable(),
    organizationId: z.string().uuid(),
  })
  .merge(timestampSchema);

// Create user
export const createUserSchema = z.object({
  email: z.string().email(),
  name: z.string().min(1).max(100),
  role: z.enum(['admin', 'agent', 'viewer']).default('agent'),
  password: z.string().min(8).max(100).optional(), // Optional for invited users
});

// Update user
export const updateUserSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  role: z.enum(['admin', 'agent', 'viewer']).optional(),
  status: z.enum(['active', 'invited', 'suspended']).optional(),
});

// User list with pagination
export const userListResponseSchema = z.object({
  users: z.array(userSchema),
  pagination: z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
    totalPages: z.number(),
  }),
});

// Export inferred types
export type User = z.infer<typeof userSchema>;
export type CreateUserInput = z.infer<typeof createUserSchema>;
export type UpdateUserInput = z.infer<typeof updateUserSchema>;
export type UserListResponse = z.infer<typeof userListResponseSchema>;
